import { useEffect } from 'react';
import useMeQuery from '@hooks/useMeQuery';
import usePreferredTimezone from '@hooks/usePreferredTimezone';
import { EVENT_TIME_BUTTON, LOCAL_TIME_BUTTON } from '@context/TimezoneContext';
import { Format } from '@graphql/gql/graphql';

const useDefaultTimeZone = (): void => {
  const {
    data: { me: { event: { format = null, timezone = null, timezoneId = null } = {}, virtual = null } = {} } = {}
  } = useMeQuery();
  const { setEventData } = usePreferredTimezone();

  useEffect(() => {
    if (timezone) {
      if (format === Format.InPerson || (format === Format.Hybrid && virtual === false)) {
        setEventData(timezone, timezoneId, EVENT_TIME_BUTTON);
      } else {
        setEventData(timezone, timezoneId, LOCAL_TIME_BUTTON);
      }
    }
  }, [format, virtual, timezone, timezoneId, setEventData]);
};

export default useDefaultTimeZone;
